import { unsetTextStyleAttribute as e } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
import { useTextColorExtensionToolbar as t } from "./use-text-color-extension-toolbar.mjs";
import { Extension as n } from "@tiptap/core";
//#region src/extensions/text-color-extension/index.ts
var r = n.create({
	name: "color",
	addOptions() {
		return { types: ["textStyle"] };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { color: {
				default: null,
				parseHTML: (e) => e.style.color?.replace(/['"]+/g, ""),
				renderHTML: (e) => e.color ? { style: `color: ${e.color}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setColor: (e) => ({ chain: t }) => t().setMark("textStyle", { color: e }).run(),
			unsetColor: () => ({ tr: t, state: n, dispatch: r }) => e("color", n, t, r)
		};
	}
});
//#endregion
export { r as TextColor, t as useTextColorExtensionToolbar };
